import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactCompareImage from "react-compare-image";

function CompareViewer({ baseURL }) {
  const { folderId } = useParams();
  const [before, setBefore] = useState(null);
  const [after, setAfter] = useState(null);
  const [error, setError] = useState(false);
  const [logo, setLogo] = useState(null);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch(`${baseURL}/api/images/${folderId}`);
        const data = await res.json();

        if (data.before && data.after) {
          setBefore(`${baseURL}${data.before}`);
          setAfter(`${baseURL}${data.after}`);
          if (data.logo) setLogo(`${baseURL}${data.logo}`);
          if (data.meta) setMeta(data.meta);
        } else {
          setError(true);
        }
      } catch (err) {
        setError(true);
      }
    };

    fetchImages();
  }, [folderId]);

  if (error) return <p style={{ color: "white" }}>Images not found.</p>;
  if (!before || !after) return <p style={{ color: "white" }}>Loading...</p>;

  return (
//     <div
//       style={{
//         height: "100vh",
//         background: "#1e1e1e",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
// <div
//   style={{
//     minHeight: "100vh",
//     background: "#1e1e1e",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "flex-start",
//     paddingTop: "60px", // Editor header height
//     boxSizing: "border-box",
//     overflow: "auto",
//   }}
// >
//   <div
//     style={{
//       width: "min(95vw, 900px)",
//       aspectRatio: meta?.imageRatio?.replace(":", "/") || "3 / 2",
//       position: "relative",
//       backgroundColor: "#000",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//     }}
//   >
//     <div
//       className="compare-wrapper"
//       style={{
//         width: "100%",
//         height: "100%",
//         position: "relative",
//       }}
//     >
//       <ReactCompareImage
//         leftImage={before}
//         rightImage={after}
//         vertical={meta?.direction === "vertical"}
//         handle={
//           <img
//             src={
//               meta?.direction === "vertical"
//                 ? "/icons/fav-ver.png"
//                 : "/icons/fav.png"
//             }
//             alt="Handle"
//             className="custom-handle"
//           />
//         }
//       />
//       {logo && meta?.logoPosition && (
//         <img
//           src={logo}
//           alt="Overlay Logo"
//           style={{
//             position: "absolute",
//             top: meta.logoPosition.top,
//             left: meta.logoPosition.left,
//             width: `${meta.logoSize}px`,
//             pointerEvents: "none",
//           }}
//         />
//       )}
//     </div>
//   </div>
// </div>




//     </div>
<div className="preview-area">
{before && after ? (
  <div
    className="preview-box"
    style={{ aspectRatio: meta?.imageRatio?.replace(":", "/") || "3 / 2", }}
  >
    <div className="compare-wrapper">
      <div className="compare-inner">
        <ReactCompareImage
          leftImage={before}
          rightImage={after}
          sliderPositionPercentage={0.5}
          vertical={meta?.direction === "vertical"}
          handle={
            <img
              src={
                meta?.direction === "vertical"
                  ? "/icons/fav-ver.png"
                  : "/icons/fav.png"
              }
              alt="Slider Handle"
              className="custom-handle"
            />
          }
        />
      </div>

      {logo && (
        <div
          className="draggable-logo-wrapper"
          style={{
                        position: "absolute",
                        top: meta.logoPosition.top,
                        left: meta.logoPosition.left,
                        width: `${meta.logoSize}px`,
                        pointerEvents: "none",
                      }}
        >
          <img
            src={logo}
            alt="Draggable Logo"
            className="draggable-logo"
          />
          <div
            // className="resize-handle"
            // onMouseDown={startResize}
          ></div>
        </div>
      )}
    </div>
  </div>
) : (
  <p style={{ color: "#aaa" }}>
    Please upload both Before and After photos to preview.
  </p>
)}
</div>
  );


}

export default CompareViewer;
